import Swiper from 'swiper';
import {
  Pagination,
  EffectFade,
  Navigation,
  Autoplay,
  Thumbs
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

export function initializeSwiper() {
  const swiperHomeHero = new Swiper('.swiper-home-hero', {
    modules: [Pagination, EffectFade, Autoplay, Navigation],
    slidesPerView: 1,
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-home-hero .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-home-hero .swiper-button-next',
      prevEl: '.swiper-home-hero .swiper-button-prev',
    },
  });

  const swiperHomeHeroText = new Swiper('.swiper-home-hero-text', {
    modules: [Pagination, EffectFade, Autoplay, Navigation],
    slidesPerView: 1,
    // effect: 'fade',
    loop: true,
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-home-hero-text .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-home-hero-text .swiper-button-next',
      prevEl: '.swiper-home-hero-text .swiper-button-prev',
    },
  });

  const swiperTestimonialText = new Swiper('.swiper-testimonial-text', {
    modules: [Pagination, EffectFade, Autoplay, Navigation],
    slidesPerView: 1,
    loop: true,
    spaceBetween: 24,
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-testimonial-pagination.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-testimonial-next.swiper-button-next',
      prevEl: '.swiper-testimonial-prev.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });



  const swiperContentCard = new Swiper('.swiper-content-card', {
    modules: [Pagination, EffectFade, Autoplay, Navigation],
    slidesPerView: 2,
    loop: true,
    spaceBetween: 12,
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-testimonial-pagination.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-testimonial-next.swiper-button-next',
      prevEl: '.swiper-testimonial-prev.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  });


  const swiperPromo = new Swiper('.swiper-promotion', {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-promotion ~ .swiper-button-next',
      prevEl: '.swiper-promotion ~ .swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  const swiperVenueGallery = new Swiper('.swiper-venue-gallery', {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-venue-gallery ~ .swiper-button-next',
      prevEl: '.swiper-venue-gallery ~ .swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
    },
  });

  const swiperContents = document.querySelectorAll('.swiper-contents');
  swiperContents.forEach((sliderEl) => {
    const controlsScope = sliderEl.closest('.swiper-outwrap') || sliderEl.parentElement || sliderEl;
    new Swiper(sliderEl, {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: controlsScope.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: controlsScope.querySelector('.swiper-button-next'),
        prevEl: controlsScope.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  // Loop mode reorders the slides in the DOM, which breaks the chronological
  // order of the events, so keep it off.
  const swiperUpcomingEvent = new Swiper('.swiper-upcoming-event', {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    // loopAdditionalSlides: 1,
    // watchSlidesProgress: true,
    // slideToClickedSlide: false,
    // allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-upcoming-event ~ .swiper-button-next',
      prevEl: '.swiper-upcoming-event ~ .swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 3
      },
    },

  });

  const swiperPromoBanner = new Swiper('.swiper-promo-banner', {
    modules: [Pagination, Navigation, Autoplay],
    slidesPerView: 2,
    spaceBetween: 12,
    autoplay: {
      delay: 5000,
    },
    speed: 1000,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 4
      },
    },

  });


  // const swiperPostSimple = new Swiper('.swiper-post-simple', {
  //     modules: [Pagination],
  //     slidesPerView: 2,
  //     spaceBetween: 12,
  //     speed: 1000,
  //     autoHeight: false,       // Ensure this is false or omitted!
  //     loop: true,
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     breakpoints: {
  //       768: { 
  //         slidesPerView: 4,
  //         spaceBetween: 24,
  //       },
  //     },
  // });
  document.querySelectorAll('.swiper-post-simple').forEach((slider) => {
    const pagination = slider.querySelector('.swiper-pagination');

    new Swiper(slider, {
      modules: [Pagination],
      slidesPerView: 2,
      // slidesPerGroup: 2,
      spaceBetween: 12,
      speed: 1000,
      autoHeight: false,
      loop: true,

      pagination: {
        el: pagination,
        clickable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 24,
          // slidesPerGroup: 4,
        },
      },
    });
  });


}
